import "./style.scss";

import React, { FC, useContext, useState } from "react";

import Alert from "shared/ui/Alert";
import Button from "shared/ui/Button";
import { Button_Style } from "shared/ui/Button/Button";
import { DocumentUnion } from "shared/types/types";
import { DocumentsContext } from "features/documents";
import Table from "components/Table";
import { useNavigate } from "react-router-dom";
import DocumentTypeSelect from "components/DocumentTypeSelect";
import FileDownloadInstructions from "components/FileDownloadInstructions";
import DocumentUpload from "components/DocumentUpload";
import VerifyDatabaseDocument from "components/VerifyDatabaseDocument";
import MultipleSelect from "shared/ui/MultipleSelect";
import Input from "shared/ui/Input";
import Checkbox from "shared/ui/Checkbox";

const columns = [
  { key: "number", label: "NUMÉRO" },
  { key: "dateExpiration", label: "EXP" },
  { key: "status", label: "STATUT" },
  { key: "nationality", label: "" },
  { key: "type", label: "Type" },
];

const optionsReason = [
  { value: 'Victime d’une arnaque sur internet', label: 'Victime d’une arnaque sur internet' },
  { value: 'J’ai répondu à une fausse annonce de location', label: 'J’ai répondu à une fausse annonce de location' },
  { value: 'Je suis victime d’une fuite de données', label: 'Je suis victime d’une fuite de données' },
  { value: 'Mon adresse e-mail/ordinateur a été piraté', label: 'Mon adresse e-mail/ordinateur a été piraté' },
  { value: 'Autre', label: 'Autre' },
]


interface IDAssistantSelectDocumentProps {
    steps: any;
    setDatas: (data: any) => void;
    datas: any;
    handlePreviousStep: () => void;
    handleNextStep: () => void;
    withUploadedDocument?: boolean;
}

const IDAssistantSelectDocument: FC<IDAssistantSelectDocumentProps> = ({
   setDatas,
   datas,
    steps,
   handlePreviousStep,
   handleNextStep,
  withUploadedDocument = false

}) => {
    const [selectedRows, setSelectedRows] = useState<DocumentUnion[]>([]);
    const { allDocuments } = useContext(DocumentsContext);
    const navigate = useNavigate();
    const handleSelectionChange = (rows: DocumentUnion[]) => {
        const rowsIds = rows.map((row) => row.id);
        setSelectedRows(rows);
        setDatas({ ...datas, documents_ids: rowsIds });
    };

  const [selectedFiles, setSelectedFiles] = useState<any>(datas.docsToUpload);
  const [requiredFiles, setRequiredFiles] = useState<number>(1);

  const [type, setType] = useState<string>(datas.typeDoc);
  const [docNumber, setDocNumber] = useState<string>(datas.docNumber);
  const [docCodeCountry, setDocCodeCountry] = useState<string>(datas.docCodeCountry);
  const [autre, setAutre] = useState<string>("");
  const [verificationDone, setVerificationDone] = useState<boolean>(false);


  const onChangeType = (type: string) => {
    setType(type);
    setDatas({ ...datas, typeDoc: type });
  };


  const handleChange = (value: string) => {
    onChangeType(value);
    setSelectedFiles([]);
    if (value === "Passeport") {
      setRequiredFiles(1);
    } else {
      setRequiredFiles(1);
    }
  };

  const handleSubmitForWithUploadedDocument = ()=> {
    setDatas({
      ...datas,
      typeDoc: type,
      docsToUpload: selectedFiles,
      docNumber: docNumber,
      docCodeCountry: docCodeCountry,
    });

    let raisons = [...datas?.raisons];
    const index = raisons.indexOf(optionsReason[4]);
    if (index > -1) { // only splice array when item is found
      raisons.splice(index, 1); // 2nd parameter means remove one item only
      setDatas({
        ...datas,
        raisons: [...raisons,  { value: autre, label: 'Autre' }]
      })
    }

    console.log(datas);

    return handleNextStep();
  }

    return (
        <div className="IDAssistantSelectDocument w-100 d-flex flex-column align-items-center justify-content-between">
            <div className="w-100">
                <h3>Vos documents d'identités</h3>
                <p className="mb-1">
                    Vous pouvez ajouter plusieurs documents à votre déclaration de perte ou de vol. Sélectionnez les depuis votre espace ID
                    Protect ou ajoutez un nouveau document.
                </p>

                <MultipleSelect
                  options={optionsReason}
                  closeMenuOnSelect={true}
                  label={"Raisons"}
                  className={"mb-1"}
                  value={datas.raisons}
                  onChange={(value: any)=> setDatas({ ...datas, raisons: value})}
                />

              {datas?.raisons.includes(optionsReason[4]) && (
                <>
                  <Input
                    onChange={(value: any)=> {
                      setAutre(value.target.value);
                    }}
                    required={true}
                    placeholder="Autre raison"
                    name="autre"
                    type="text"
                    value={autre}
                  />
                </>
              )}

                {!withUploadedDocument ? (
                  <>
                      {allDocuments.length > 0 && (
                        <Alert type="warning">Vos documents d'identités seront mis en opposition. Cette action est irréversible.</Alert>
                      )}
                      <div className="IDAssistantSelectDocument__table">
                          <Table
                            className="mb-0"
                            columns={columns}
                            rows={allDocuments}
                            onSelectionChange={handleSelectionChange}
                            selectedRows={selectedRows}
                            size="S"
                            selectable
                          />
                      </div>
                  </>
                ) : (
                  <>
                    <VerifyDatabaseDocument
                      setType={handleChange}
                      type={type}
                      verificationDone={false}
                      setVerificationDone={setVerificationDone}
                      hideHeader={true}
                      hideBtn={true}
                      setDocNumber={setDocNumber}
                      docNumber={docNumber}
                      setDocCountryCode={setDocCodeCountry}
                      docCountryCode={docCodeCountry}
                      showTrusfullVerification={false}
                    />
                    <div className="addDocumentForm__buttons">
                      {type && (
                       <>
                         <DocumentUpload
                           type={type}
                           setSelectedFiles={setSelectedFiles}
                           selectedFiles={selectedFiles}
                         />
                       </>
                      )}
                    </div>
                  </>
                )}
              <Checkbox
                label="Je confirme être le titulaire des documents d’identité"
                onChange={(value: any)=> {
                  setDatas({ ...datas, ownerOfThisDoc: value.target.checked});
                }}
                checked={datas.ownerOfThisDoc}
              />
            </div>
          <div className={`d-flex justify-content-${!steps[0].isCurrent ? "between" : "end"} w-100`}>
            {!steps[0].isCurrent && (
              <Button
                label={"Retour"}
                onClick={() => handlePreviousStep()}
                style={Button_Style.OUTLINED}
              />
            )}
            {!withUploadedDocument ? (
              <>
                {allDocuments.length === 0 ? (
                  <Button
                    label="Ajouter un document"
                    onClick={() => navigate("/particuliers/idtracker")}
                  />
                ) : (
                  <Button
                    disabled={datas?.documents_ids.length === 0}
                    label={"Suivant"}
                    onClick={() => handleNextStep()}
                  />
                )}
              </>
            ): (
              <>
                  <Button
                    disabled={selectedFiles?.length === 0 || docNumber === ''}
                    label={`Suivant`}
                    onClick={handleSubmitForWithUploadedDocument}
                  />
              </>
            )}

            </div>
        </div>
    );
};

export default IDAssistantSelectDocument;
